import "./App.css";
import { Routes, Route } from "react-router-dom";

import {
  HomePage,
  BisnisPage,
  DetailPage,
  LembagaPage,
  LiveStreaming,
  PendidikanPage,
  Kumpulan,
  ContentDetail,
  GaleriPage,
  // JenjangPage,
  KomunitasPage,
} from "./pages";
import { Suspense } from "react";
import useAnalytics from "./lib/useAnalytics";
import HubungiKami from "./pages/HubungiKami";
import KebijakanPrivasi from "./pages/KebijakanPrivasi";
import SyaratKetentuan from "./pages/SyaratKetentuan";
import PageUnderDevelopment from "./pages/PageUnderDevelopment";
function App() {
  useAnalytics();

  const Load = () => {
    return (
      <div className="h-screen w-full flex items-center justify-center text-base-semibold">
        Loading...
      </div>
    );
  };

  return (
    <Suspense fallback={<Load />}>
      <Routes>
        {/* umum  */}
        <Route path="/" element={<HomePage />} />
        <Route path="/bisnis" element={<BisnisPage />} />
        <Route path="/lembaga" element={<LembagaPage />} />
        <Route path="/pendidikan" element={<PendidikanPage />} />
        <Route path="/livestreaming" element={<LiveStreaming />} />
        <Route path="/kumpulan/:params" element={<Kumpulan />} />
        <Route path="/content/:page/:id/:slug" element={<ContentDetail />} />
        <Route path="/profile/:id" element={<ContentDetail page="profile" />} />
        <Route
          path="/bidang/sarana-prasarana"
          element={<GaleriPage type="sarana-prasarana" />}
        />
        <Route path="/bidang/:id" element={<ContentDetail page="bidang" />} />
        <Route path="/headline/:id/:slug" element={<DetailPage />} />
        <Route path="/galeri" element={<GaleriPage />} />
        <Route path="/publikasi/galeri" element={<GaleriPage />} />
        <Route
          path="/publikasi/prestasi"
          element={<GaleriPage type="prestasi" />}
        />
        <Route path="/publikasi/berita" element={<Kumpulan type="berita" />} />
        <Route path="/publikasi/agenda" element={<Kumpulan type="agenda" />} />
        <Route
          path="/publikasi/artikel"
          element={<Kumpulan type="artikel" />}
        />
        <Route
          path="/publikasi/karya-siswa"
          element={<GaleriPage type="karya-siswa" />}
        />
        <Route
          path="/bidang/program-unggulan"
          element={<GaleriPage type="program-unggulan" />}
        />
        {/* <Route path="/jenjang/:jenjangId" element={<JenjangPage />} /> */}
        <Route path="/publikasi/komunitas" element={<KomunitasPage />} />

        {/* Footer */}
        <Route path="/hubungi-kami" element={<HubungiKami />} />
        <Route path="/kebijakan-privasi" element={<KebijakanPrivasi />} />
        <Route path="/syarat-ketentuan" element={<SyaratKetentuan />} />

        {/* Not Found Page */}
        <Route
          path="/layanan/perpustakaan-digital"
          element={<PageUnderDevelopment />}
        />
      </Routes>
    </Suspense>
  );
}

// jjjj

export default App;
